module.exports = __webpack_public_path__ + "static/media/somwarpet.8c50cd16.jpg";